import { inject, Injectable, signal } from '@angular/core';
import { AuthStore } from '@auth';
import { UserService } from '@data';
import { SelectOption } from '@form';
import { LocalStorageStore } from '@localStore';
import { map, Observable } from 'rxjs';
import { LOCAL_STORAGE_SELECTED_TENANTS_KEY } from '../constants/tenants.constants';

@Injectable({ providedIn: 'root' })
export class TenantsService {
  private authStore = inject(AuthStore);
  private localStorage = inject(LocalStorageStore);
  private userService = inject(UserService);

  tenants = this.getStoreTenants();
  selectedTenants = signal<string[]>(this.retrieveSelectedTenants());

  constructor() {}
  /**
   * Clears selected tenants from localStorage and state.
   */
  clearSelectedTenants() {
    this.localStorage.removeItem(LOCAL_STORAGE_SELECTED_TENANTS_KEY);
    this.selectedTenants.set([]);
  }

  getStoreTenants() {
    return this.authStore.tenants;
  }

  getUserTenants() {
    return this.userService.getUserTenants();
  }

  getTenantOptions(): Observable<SelectOption[]> {
    return this.getUserTenants().pipe(
      map((userTenants) =>
        userTenants.map((tenant) => ({
          label: tenant.label,
          value: tenant.distributorId || '',
        })),
      ),
    );
  }

  saveSelectedTenants(selectedTenants: string[]) {
    this.localStorage.setItem(
      LOCAL_STORAGE_SELECTED_TENANTS_KEY,
      selectedTenants,
    );
    this.selectedTenants.set([...selectedTenants]);
  }

  retrieveSelectedTenants(): string[] {
    return (
      this.localStorage.getItem<string[]>(LOCAL_STORAGE_SELECTED_TENANTS_KEY) ??
      []
    );
  }
}
